import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import NoDataMessage from "./NoDataMessage";
import "./Table.css";

const MuiTable = React.memo((props) => {


const {
  rows,
  columns,
  errorMessage,
  activeRowId,
  getRowHeight,
} = props;



  const theme = useTheme();
  // Checks if the screen width is extra-small (xs / below 600px)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Helper logic to show a clean sliding window of pages on mobile (e.g., max 3 buttons)


  return (
    <Box
      className="table-wrapper"
      sx={{
        width: "100%",
        overflowX: "hidden",

      }}
    >
      {rows?.length === 0 ? (
        <NoDataMessage findItemType={errorMessage} />
      ) : (
        <>
          <DataGrid
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableRowSelectionOnClick
            hideFooterPagination
            getRowClassName={(params) =>
              params.id === activeRowId ? "active-row" : ""
            }
            getRowHeight={getRowHeight}
            rowHeight={getRowHeight ? undefined : 48}
            sx={{
              height: isMobile ? 400 : 560,


              "& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select": {
                fontSize: "13px",
              },
            }}
          />



        </>
      )}
    </Box>
  );
});

export default MuiTable;